
import React from "react";
import { Badge } from "@/components/ui/badge";
import { SaveCountDisplay } from "./SaveCountDisplay";

type Entry = {
  entry_type: string;
  is_postscript?: boolean;
  save_count?: number;
};

type EntryCardBadgesProps = {
  entry: Entry;
  isSharedEntryState: boolean;
  isOwner: boolean;
};

export const EntryCardBadges: React.FC<EntryCardBadgesProps> = ({
  entry,
  isSharedEntryState,
  isOwner
}) => {
  return (
    <div className="flex flex-wrap gap-1 my-1">
      <Badge variant="outline" className="text-xs">
        {entry.entry_type}
      </Badge>
      {isSharedEntryState && (
        <Badge variant="outline" className="text-xs bg-blue-100 text-blue-800 border-blue-300">
          Shared
        </Badge>
      )}
      {entry.is_postscript && (
        <Badge variant="outline" className="text-xs bg-purple-100 text-purple-800 border-purple-300">
          Postscript
        </Badge>
      )}
      <SaveCountDisplay 
        saveCount={entry.save_count || 0} 
        isCreator={isOwner} 
        showInline 
      />
    </div>
  );
};
